import React from "react";
import HorizontalPositionSettings from "fantastic/components/common/controls/background/HorizontalPositionSettings";

export default ({ onChange, node }) => {
  const params = {
    onChange,
    scrollToIfNeeded: () => {},
    position: {
      field: "text_align",
      value: node.text_align
    }
  };

  return (
    <div className="form-group">
      <label>{ i18n.t('text_align') }</label>
      <div>
        <HorizontalPositionSettings {...params} />
      </div>
    </div>
  );
};
